import { combineReducers } from "@reduxjs/toolkit";

import authReducer from "./auth_reducer";
import conferenceReducer from "./conference_reducer";
import licenseReducer from "./license_reducer";
import pupilageReducer from "./pupilage_reducer";
import duesReducer from "./dues_reducer";
import chamberReducer from "./chamber_reducer";
import paymentReducer from "./payment_reducer";
import glcReducer from "./glc_reducer";
import stickerReducer from "./sticker_reducer";
import mainReducer from "./main_reducer";
import bootcampReducer from "./bootcamp_reducer";
import trainingReducer from "./training_reducer";
import talkReducer from "./talk_reducer";
import surveyReducer from "./survey_reducer";
import grievanceReducer from "./grievance_reducer";

const rootReducer = combineReducers({
  auth: authReducer,
  conference: conferenceReducer,
  license: licenseReducer,
  pupilage: pupilageReducer,
  dues: duesReducer,
  chamber: chamberReducer,
  payment: paymentReducer,
  glc: glcReducer,
  sticker: stickerReducer,
  main: mainReducer,
  bootcamp: bootcampReducer,
  training: trainingReducer,
  talk: talkReducer,
  survey: surveyReducer,
  grievance: grievanceReducer,
});

export default rootReducer;
